<template>
    <div class="layout-container">
        <HeaderVue></HeaderVue>
        <div class="sidebar">
            <el-menu :default-active="$route.path" active-text-color="#7B2820" unique-opened>
                <template v-for="(item, index) in menuItems">
                    <!-- 无子菜单 -->
                    <el-menu-item :key="index" v-if="!item.children" :index="item.path" @click.native="handleMenuItemClick(item.title, item.path, item.query)">
                        <div style="display: flex; align-items: center">
                            <img v-if="item.icon" :src="item.icon" alt="" style="margin-right: 10px; width: 34px" />
                            <span slot="title" class="font20">{{ item.title }}</span>
                        </div>
                    </el-menu-item>

                    <!-- 有子菜单 -->
                    <template v-else>
                        <el-submenu :index="item.path || item.title" :key="index">
                            <template #title>
                                <div style="display: flex; align-items: center">
                                    <img v-if="item.icon" :src="item.icon" alt="" style="margin-right: 10px; width: 24px" />
                                    <span slot="title" class="font18">{{ item.title }}</span>
                                </div>
                            </template>
                            <el-menu-item v-for="child in item.children" :key="child.path" :index="child.path" class="font16" @click.native="handleMenuItemClick(child.title, child.path, child.query)">
                                {{ child.title }}
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </template>
            </el-menu>
        </div>

        <div class="main-container">
            <div class="tabs-container">
                <el-tabs v-model="activeTab" type="card" @tab-remove="removeTab" @tab-click="changeTab">
                    <el-tab-pane v-for="item in visitedViews" :closable="!item.fixed" :key="item.path" :label="item.title" :name="item.path">
                        <div class="layout-content">
                            <router-view v-if="$route.path === item.path" :key="item.path" />
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderVue from './Header.vue';
import imService from '@/utils/imService';
const menuItems1 = [
    {
        title: '工作台',
        icon: new URL('@/images/1-04.png', import.meta.url).href,
        path: '/',
        fixed: true,
    },
    {
        title: '患者信息',
        icon: new URL('@/images/1-05.png', import.meta.url).href,
        children: [{ title: '患者列表', path: '/patient/list' }],
    },
    {
        title: '订单管理',
        icon: new URL('@/images/1-06.png', import.meta.url).href,
        children: [
            { title: '问诊单', path: '/orders/consultation' },
            { title: '处方单', path: '/orders/prescription' },
            { title: '药品订单', path: '/orders/drug' },
        ],
    },
    {
        title: '用户中心',
        icon: new URL('@/images/1-07.png', import.meta.url).href,
        children: [
            { title: '我的排班', path: '/user/schedule' },
            { title: '我的评价', path: '/user/reviews' },
            { title: '处方模板', path: '/user/templates' },
            { title: '我的医助', path: '/user/myYizhu' },
            { title: '我的医嘱', path: '/user/medicakAdvice' },
        ],
    },
    {
        title: '设置',
        icon: new URL('@/images/1-08.png', import.meta.url).href,
        children: [
            { title: '消息通知', path: '/settings/notifications' },
            // { title: '注册协议', path: '/settings/agreement' },
            // { title: '隐私协议', path: '/settings/privacy' },
            { title: '修改密码', path: '/settings/change-password' },
        ],
    },
    {
        title: '会话',
        icon: new URL('@/images/1-08.png', import.meta.url).href,
        children: [{ title: '会话列表', path: '/user/messageList' }],
    },
];
const menuItems2 = [
    {
        title: '工作台',
        icon: new URL('@/images/1-04.png', import.meta.url).href,
        path: '/',
        fixed: true,
    },
    {
        title: '患者信息',
        icon: new URL('@/images/1-05.png', import.meta.url).href,
        children: [{ title: '患者列表', path: '/patient/list' }],
    },
    {
        title: '订单管理',
        icon: new URL('@/images/1-06.png', import.meta.url).href,
        children: [
            { title: '问诊单', path: '/orders/consultation' },
            { title: '药品订单', path: '/orders/drug' },
        ],
    },
    {
        title: '用户中心',
        icon: new URL('@/images/1-07.png', import.meta.url).href,
        children: [{ title: '我的排班', path: '/user/schedule' }],
    },
    {
        title: '设置',
        icon: new URL('@/images/1-08.png', import.meta.url).href,
        children: [
            { title: '消息通知', path: '/settings/notifications' },
            // { title: '注册协议', path: '/settings/agreement' },
            // { title: '隐私协议', path: '/settings/privacy' },
            { title: '修改密码', path: '/settings/change-password' },
        ],
    },
    {
        title: '会话',
        icon: new URL('@/images/1-08.png', import.meta.url).href,
        children: [{ title: '会话列表', path: '/user/messageList' }],
    },
];
export default {
    name: 'Layout_vue',
    components: { HeaderVue },
    data() {
        return {
            activeTab: this.$route.path,
            visitedViews: [],
            menuItems: '',
        };
    },
    watch: {
        $route(to) {
            this.activeTab = to.path;
            this.addView(to);
        },
        // 监听 visitedViews 变化，自动保存到 localStorage
        visitedViews: {
            handler(newVal) {
                localStorage.setItem('visitedViews', JSON.stringify(newVal));
            },
            deep: true,
        },
    },
    created() {
        this.menuItems = localStorage.getItem('userType') == 1 ? menuItems1 : menuItems2;
        const savedViews = localStorage.getItem('visitedViews');
        if (savedViews) {
            this.visitedViews = JSON.parse(savedViews);
        } else {
            this.addView(this.$route); // 默认加载当前路由
        }
    },
    methods: {
        addView(route) {
            console.log(route, 'route');
            console.log(this.visitedViews, 'this.visitedViews');
            imService.login(localStorage.getItem('user_id'), localStorage.getItem('sign'));
            const { path, meta } = route;
            const title = meta.title || '工作台';
            const exists = this.visitedViews.some((v) => v.path === path);

            if (!exists) {
                this.visitedViews.push({ path, title, fixed: path === '/', query: route.query });
            }

            this.activeTab = path;
        },
        removeTab(targetName) {
            if (targetName === '/') {
                this.$message.warning('工作台不可关闭');
                return;
            }

            let tabs = [...this.visitedViews];
            let activeName = this.activeTab;

            const index = tabs.findIndex((tab) => tab.path === targetName);
            if (index !== -1) {
                tabs.splice(index, 1);
                if (activeName === targetName) {
                    const nextTab = tabs[index] || tabs[index - 1];
                    if (nextTab) {
                        activeName = nextTab.path;
                        this.$router.push(nextTab.path);
                    }
                }
            }

            this.visitedViews = tabs;
            this.activeTab = activeName;
        },
        changeTab(tab) {
            // console.log(tab);
            // console.log(this.$route.path);
            // this.$store.dispatch('publicStore/setName', tab.label);
            // if (this.$route.path !== tab.name) {
            //     this.$router.push(tab.name);
            // }
            const targetView = this.visitedViews.find((v) => v.path === tab.name);
            this.$store.dispatch('publicStore/setName', tab.label);

            if (targetView && this.$route.path !== tab.name) {
                this.$router.push({
                    path: tab.name,
                    query: targetView.query || {},
                });
            }
        },
        handleMenuItemClick(name, url, query) {
            console.log(name);
            console.log(query, 'query');

            if (this.$route.path !== url) {
                this.$store.dispatch('publicStore/setName', '');
                this.$store.dispatch('publicStore/setName', name);
                this.$router.push(url).catch((err) => {
                    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
                        console.error('菜单跳转失败:', err);
                    }
                });
            }
        },
    },
    mounted() {
        // 页面加载时恢复 Tabs 状态
        const storedViews = localStorage.getItem('visitedViews');
        if (storedViews) {
            this.visitedViews = JSON.parse(storedViews);
            // 如果存储中有与当前路由匹配的 Tab，则激活它；否则默认激活工作台
            const currentRouteTab = this.visitedViews.find((view) => view.path === this.$route.path);
            this.activeTab = currentRouteTab ? currentRouteTab.path : '/';
        } else {
            // 默认情况下添加工作台
            this.addView(this.$route);
        }
    },
};
</script>

<style lang="less" scoped>
.layout-container {
    width: 100%;
    height: 100vh;
    min-width: 1800px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
}
.sidebar {
    width: 220px;
    background-color: #fff;
    height: calc(100vh - 90px);
    .el-menu {
        height: 100%;
    }
}
.tabs-container {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    height: calc(100vh - 60px);
    overflow-y: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    :deep(.el-tabs__item) {
        border: none !important;
        background-color: transparent;
        color: #333;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        background-color: #fff;
        border-radius: 5px;
        margin-right: 10px;

        &.is-active {
            background-color: #fff;
            border-radius: 5px;
            color: #7b2820;
            font-weight: bold;
        }
    }

    :deep(.el-tabs__nav) {
        border: none !important;
        display: inline-flex;
        min-width: 100%;
    }

    :deep(.el-tabs__header) {
        margin-bottom: 0;
        border-bottom: none !important;
    }

    :deep(.el-icon-close) {
        font-size: 12px;
        color: #ff4d4f;

        &:hover {
            color: #ff4d4f;
        }
    }
}

.main-container {
    width: calc(100% - 220px);
    height: calc(100vh - 90px);
    background-color: #f4f4f4;
}

.layout-content {
    width: 100%;
    // margin-top: 10px;
    height: calc(100vh - 90px - 45px);

    overflow: auto;
}
::v-deep .el-tabs--card > .el-tabs__header {
    border-bottom: none;
    .el-tabs__nav {
        border: none;
    }
}
::v-deep .el-tabs__item {
    background-color: #fff;
    border-radius: 10px;
    border: none;
}
.font16 {
    font-size: 14px !important;
}
.font18 {
    font-size: 16px !important;
}
.font20 {
    font-size: 18px !important;
}
</style>
